import * as React from 'react';
import { Col } from 'reactstrap';
import { momentToString, momentAgeNow } from 'src/share/utils/utils';
import { IPosterPrintPersonProps } from '../PosterPrint';

const PosterPersonInformation = (props: IPosterPrintPersonProps) => {
    const { companionType = null } = props.personInfo as any
    return (
        <div className={'poster-child-information'}>
            <Col className={'col-6 information-col subFont'}>
                <div className="case-data">
                    <p><label>Date of Birth:</label>{props.personInfo && props.personInfo.birthDate ? `${momentToString(props.personInfo.birthDate)}` : 'Unknown'}</p>
                    <p><label>Current Age:</label>{props.personInfo && props.personInfo.birthDate ? momentAgeNow(props.personInfo.birthDate) : 'Unknown'}</p>
                    <p><label>Eye Color:</label>{props.personInfo && props.personInfo.eyeColor || 'Unknown'}</p>
                    <p><label>Hair Color:</label>{props.personInfo && props.personInfo.hairColor || 'Unknown'}</p>
                </div>
            </Col>
            <Col className={'col-6 information-col subFont'}>
                <div className="case-data">
                    <p><label>Sex:</label>{props.personInfo && props.personInfo.sex || 'Unknown'}</p>
                    <p><label>Height:</label>{props.personInfo && props.personInfo.height && props.personInfo.heightUnit ? `${props.personInfo.height} ${props.personInfo.heightUnit}` : 'Unknownn'}</p>
                    <p><label>Weight:</label>{props.personInfo && props.personInfo.weight && props.personInfo.weightUnit ? `${props.personInfo.weight} ${props.personInfo.weightUnit}` : 'Unknownn'}</p>
                    {companionType && <p><label>Companion Type:</label>{companionType || 'Unknown'}</p>}
                </div>
            </Col>
        </div>
    )
};

export default PosterPersonInformation;


// WEBPACK FOOTER //
// ./src/modules/Case/InformationView/components/PosterPrint/components/PosterPersonInformation.tsx